import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import SearchInput from './SearchInput';
import './index.less'

class SearchApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return <div className="global-search-wrapper">
            <SearchInput {...this.props} />
        </div>
    }
}

export default SearchApp;